import DeleteModal from './DeleteModal';
import BaseModal from './BaseModal';

export default function Modal({ type = 'default', ...props }) {
  switch (type) {
    case 'delete':
      return <DeleteModal {...props} />;
    default:
      return <BaseModal {...props} />;
  }
}
